import { useSelector } from 'react-redux';
import { getRecommendedHubletResponse } from '../store/http-responses/selectors';
export const useRecommendedHublet = () => {
  const response = useSelector(getRecommendedHubletResponse);
  let recommendedHublet = null;

  if (response) {
    const {
      region = null
    } = response;
    recommendedHublet = region;
  }

  return {
    recommendedHublet
  };
};